import PartnerBrandPoints, {PartnerBrandPointsStatus} from "../../../../model/partnerBrand/PartnerBrandPoints";
import PartnerBrandPointsSummary from "../../../../model/partnerBrand/PartnerBrandPointsSummary";
import * as _ from "underscore";
import {objectIterator} from "../../../../utils/DictionaryUtils";

export default class PartnerBrandPointsCalculator {

	static groupPartnerBrandPoints(points: PartnerBrandPoints[]): PartnerBrandPointsSummary[] {
		const grouped = _.groupBy(points, p => p.quoteId.getOrElse(p.id));
		const summaries = objectIterator(grouped).map((pbg: PartnerBrandPoints[]) => {
			let pendingPoints = 0;
			let submittedPoints = 0;
			let pendingUsed = 0;
			let submittedUsed = 0;
			pbg.forEach(pb => {
				if (pb.status === PartnerBrandPointsStatus.Pending) {
					pendingPoints += pb.amount;
					pendingUsed += pb.usedPoints;
				}
				else if (pb.status === PartnerBrandPointsStatus.Submitted || pb.status === PartnerBrandPointsStatus.NotSaved) {
					submittedPoints += pb.amount;
					submittedUsed += pb.usedPoints;
				}
			});
			const first = pbg.reduce((a, b) => a.createdAt.isBefore(b.createdAt, "minute") ? a : b);
			return new PartnerBrandPointsSummary(first.id, first.creator, first.createdAt, first.quoteId,
				first.quoteReferenceNumber,
				first.description, pendingPoints, pendingUsed, submittedPoints, submittedUsed, first.status === PartnerBrandPointsStatus.NotSaved)
		});

		return summaries.sort(PartnerBrandPointsSummary.compareByCreationDtDesc);
	}
}
